const sortOnlyOneOfEachProject = tasks => {
  const filterProjectsByUniqueName = [];

  tasks.forEach(item => {
    const currentProject = filterProjectsByUniqueName.find(
      returnedProject => returnedProject.project.name === item.project.name,
    );

    if (!currentProject) filterProjectsByUniqueName.push(item);
    return null;
  });

  return filterProjectsByUniqueName;
};

export default sortOnlyOneOfEachProject;
